module.exports = __webpack_public_path__ + "static/media/twitter.1d01cf41.svg";